import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";

const PurchaseListComponent = loadable(
  () => import("../../components/Purchase/PurchaseList")
);
const PurchaseList = () => {
  return (
    <>
      <div className={tw`flex items-center justify-between`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>Purchase</h1>
      </div>
      <PurchaseListComponent />
    </>
  );
};

export default PurchaseList;
